import { render, staticRenderFns } from "./bbs-message.vue?vue&type=template&id=036df456&scoped=true&"
import script from "./bbs-message.vue?vue&type=script&lang=js&"
export * from "./bbs-message.vue?vue&type=script&lang=js&"
import style0 from "./bbs-message.vue?vue&type=style&index=0&id=036df456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036df456",
  null
  
)

export default component.exports